import { translations as PageHeaderTranslations } from 'components/page/i18n/locales/de/translations';
import { translations as BulkActionDeTranslation } from 'containers/BulkAction/i18n/locales/de/translations';
import { translations as CampaignTranslations } from 'containers/Campaign/i18n/locales/de/translations';
import { translations } from 'containers/Customer/i18n/locales/de/translations';
import { translations as RewardDeTranslation } from 'containers/Reward/i18n/locales/de/translations';
import { translations as RuleTranslations } from 'containers/Rule/i18n/locales/de/translations';
import { translations as GlobalTranslations } from 'utils/globalTranslation/locales/de/translations';
import {
  BulkActionModule,
  CampaignModule,
  CustomerModule,
  GlobalModule,
  PageHeaderModule,
  RewardModule,
  RuleModule
} from 'utils/i18n/TModules';

export const globalTranslations = {
  [GlobalModule]: GlobalTranslations,
  [BulkActionModule]: BulkActionDeTranslation,
  [CustomerModule]: translations,
  [CampaignModule]: CampaignTranslations,
  [PageHeaderModule]: PageHeaderTranslations,
  [RuleModule]: RuleTranslations,
  [RewardModule]: RewardDeTranslation
};
